<template>
	<section class="mysection">
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-select 
						v-model="filters.company_code" filterable placeholder="请选择需要的公司" class="h-m-select">
					  <el-option v-for="item in tgs_options"
						:key="item.code" :label="item.name" v-model="item.code">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.name" placeholder="请输入话术名称"></el-input>
				</el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<div v-for="item in datalist" v-loading="listLoading">
		<el-col :span="8">
			<div class="div-cards">
				<div>
					<el-button type="primary" icon="el-icon-edit" circle size="mini" @click="handleEdit(item)"></el-button>
					<el-button type="danger" icon="el-icon-delete" circle size="mini" @click="handleDel(item)"></el-button>
				</div>
				<el-divider content-position="right" class="var-text">{{item.provider_name}}</el-divider>
				<div v-if="item.status==1" class="text item">{{item.name}}</div>
				<div v-else class="text items">{{item.name}}</div>
				<div class="itemmin">
				  SID:{{item.script_id}}<br/>
				  IID:{{item.instance_id}}
				</div>
				<div v-for="(ins,index) in item.variables" class="var-text"> 
					变量{{index+1}}:{{ins.kn}} = <font style="font-weight: bold;color:#1b79dc;text-decoration: underline;">{{ins.val}}</font>
				</div>
				<div v-for="(ins,index) in item.call_nums" class="var-text"> 
					主叫{{index+1}}:<font style="font-weight: bold;color:#a16408;text-decoration: underline;">{{ins.nm}}</font>
					前缀:{{ins.qz}}
				</div>
			</div>
		</el-col>
		</div>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--新增界面-->
		<el-drawer
		  v-loading="editViewLoading" 
		  title="新增"
		  :visible.sync="addFormVisible" :before-close="clickClose"
		  size="60%" :with-header="false"
		  direction="rtl">
			<el-form :model="editForm" label-width="80px" :rules="formRules" ref="editForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div class="to-right">
						<el-button @click.native="addFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>{{editformtitle}}</span></div>
						  <div class="text item">
							<el-form-item label="公司" class="is-required">
								{{editForm.company_name}}
							</el-form-item>
							<el-form-item label="选择脚本" prop="script_id" class="is-required">
								<el-select 
									@change="selectIntances"
									v-model="editForm.script_id" filterable placeholder="请输入/请选择" class="h-m-select">
								  <el-option v-for="item in scriptDatas"
									:key="item.script_id" :label="item.name" v-model="item.script_id">
								  </el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="变量信息" class="is-required">
								<el-table stripe :data="loabvarstr" highlight-current-row row-style="var-text">
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-row>
												<el-button type="primary" icon="el-icon-edit" circle size="mini" @click="editVars(scope.row)"></el-button>
											</el-row>
										</template>
									</el-table-column>
									<el-table-column prop="kn" label="变量名">
									</el-table-column>
									<el-table-column prop="val" label="值">
									</el-table-column>
									<el-table-column prop="rk" label="描述">
									</el-table-column>
								</el-table>
							</el-form-item>
						  </div>
						</el-card>		
					</el-main>
				</el-container>
			</el-form>
		</el-drawer>
		<el-drawer
		  title="编辑"
		  :visible.sync="editFormVisible" :before-close="clickClose"
		  size="60%" :with-header="false"
		  direction="rtl">
			<el-form :model="editForm" label-width="80px" :rules="formRules" ref="editForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div class="to-right">
						<el-button @click.native="editFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="editSaveSubmit" :loading="editLoading">保存</el-button>
					  </div>
					</el-header>
					<el-main style="padding: 50px;">
						<el-divider><font style="font-weight: bold;color:#071a2c;">编辑数据</font></el-divider>
						  <div>
							<el-form-item label="公司" class="is-required">
								{{editForm.company_name}}
							</el-form-item>
							<el-form-item label="名称" class="is-required">
								<el-input v-model="editForm.name"></el-input>
							</el-form-item>
							<el-form-item label="状态" class="is-required">
								<el-select v-model="editForm.status" placeholder="请选择状态">
									<el-option label="有效" value="1"></el-option>
									<el-option label="无效" value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="变量信息" class="is-required">
								<el-button type="primary" icon="el-icon-plus" circle size="mini" @click="addVars()"></el-button>
								<el-table stripe :data="loabvarstr" highlight-current-row row-style="var-text" :row-class-name="tableRowClassName">
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-row>
												<el-button type="primary" icon="el-icon-edit" circle size="mini" @click="editVars(scope.row)"></el-button>
												<el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeVars(scope.row.kn)"></el-button>
											</el-row>
										</template>
									</el-table-column>
									<el-table-column prop="kn" label="变量名">
									</el-table-column>
									<el-table-column prop="val" label="值">
									</el-table-column>
									<el-table-column prop="rk" label="描述">
									</el-table-column>
								</el-table>
							</el-form-item>
							<el-form-item label="主叫号码" class="is-required">
								<el-button type="primary" icon="el-icon-plus" circle size="mini" @click="addCallNums()"></el-button>
								<el-table stripe :data="loaNumberStr" highlight-current-row row-style="var-text">
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-row>
												<!-- <el-button type="primary" icon="el-icon-edit" circle size="mini" @click="editCallNum(scope.row)"></el-button>-->
												<el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeNums(scope.row.nm)"></el-button>
											</el-row>
										</template>
									</el-table-column>
									<el-table-column prop="nm" label="主叫号码">
									</el-table-column>
									<el-table-column prop="qz" label="被叫前缀">
									</el-table-column>
								</el-table>
							</el-form-item>
						  </div>
							
					</el-main>
				</el-container>
			</el-form>
		</el-drawer>
		<el-drawer
		  v-loading="editViewLoading" 
		  title="编辑变量"
		  :visible.sync="addVarsShow" :before-close="clickClose"
		  size="40%" :with-header="false"
		  direction="rtl">
			<el-form :model="addVarForm" label-width="80px" ref="addVarForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div>
						<el-button @click.native="addVarsShow = false">取消</el-button>
						<el-button type="primary" @click.native="addSaveVars">保存</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>{{editformtitle}}</span></div>
						  <div class="text item">
							<el-form-item label="变量名" class="is-required">
								<el-input v-model="addVarForm.kn"></el-input>
							</el-form-item>
							<el-form-item label="变量值">
								<el-input v-model="addVarForm.val"></el-input>
							</el-form-item>
							<el-form-item label="变量描述">
								<el-input v-model="addVarForm.rk"></el-input>
							</el-form-item>
						  </div>
						</el-card>		
					</el-main>
				</el-container>
			</el-form>
		</el-drawer>
		<el-drawer
		  title="编辑号码"
		  :visible.sync="addNumberShow" :before-close="clickClose"
		  size="40%" :with-header="false"
		  direction="rtl">
			<el-form :model="addVarForm" label-width="80px" ref="addVarForm">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->
					  <div class="to-right">
						<el-button @click.native="addNumberShow = false">取消</el-button>
						<el-button type="primary" @click.native="addSaveNums">保存</el-button>
					  </div>
					</el-header>
					<el-main>
						<el-card class="box-card">
						  <div slot="header" class="clearfix"><span>{{editformtitle}}</span></div>
						  <div class="text item">
							<el-form-item label="主叫号码" class="is-required">
								<el-select  @change="selectNumbers"
									v-model="addNumbForm.callNum" filterable placeholder="输入主叫号码" class="h-m-select">
								  <el-option v-for="item in callNumberList"
									:key="item.call_num" :label="item.call_num" v-model="item.call_num">
								  </el-option>
								</el-select>
							</el-form-item>
						  </div>
						</el-card>		
					</el-main>
				</el-container>
			</el-form>
		</el-drawer>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { getListPage, delData, saveData } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					company_code: '',name:''
				},
				datalist: [],
				total: 0,
				pagesize:15,
				page: 1,
				listLoading: false,
				scriptLoading:false,

				/////////////Form 表单
				editViewLoading:false,
				editformtitle:'',//form编辑名称
				addFormVisible:false,
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					instance_id: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],
					username: [
						{ required: true, message: '请输入账号', trigger: 'blur' }
					]
				},
				tgs_options:[],
				scriptDatas:[],
				instance_opts:[],
				script_opts:[],
				callNumberList:[],//主叫号码列表
				//编辑界面数据
				editForm: {
					actionurl:'',
					sqlid:'',
					id: 0,
					company_code:'',
					company_name:'',
					provider_code:'',
					instance_id: '',
					script_id:'',
					name:'',
					variables:'',
					status:'1',
					lines:'1',
					call_nums:''
				},
				addVarForm:{
					kn:'',val:'',rk:''
				},
				loabvarstr:[],
				addVarsShow:false,
				///////////////////
				addNumbForm:{
					callNum:'',
					bjqz:''
				},
				loaNumberStr:[],
				addNumberShow:false
			}
		},
		methods: {
			addCallNums:function(){
				this.addNumberShow = true ;
				this.addNumbForm.callNum = "";
				this.addNumbForm.bjqz="";
			},
			editCallNum:function(row){
				this.addNumberShow = true ;
				this.addNumbForm.callNum = row.nm;
			},
			addSaveNums:function(){
				let newadd = {
					nm:this.addNumbForm.callNum,
					qz:this.addNumbForm.bjqz
				};
				this.removeNums(this.addNumbForm.callNum);
				this.loaNumberStr.push(newadd);
				this.addNumberShow = false ;
			},
			removeNums:function(keystr){
				let index = this.loaNumberStr.findIndex(item => item.nm === keystr);
				//console.log("Del==>"+keystr+">>"+index);
				if (index !== -1) {
					this.loaNumberStr.splice(index, 1);
				}
			},
			removeVars:function(keystr){
				let index = this.loabvarstr.findIndex(item => item.kn === keystr);
				if (index !== -1) {
					this.loabvarstr.splice(index, 1);
				}
			},
			removeScript:function(keystr){
				let index = this.script_opts.findIndex(item => item.scriptId === keystr);
				console.log("检测:"+keystr);
				if (index !== -1) {
					this.script_opts.splice(index, 1);
				}
			},
			editVars:function(row){
				this.addVarForm.kn = row.kn;
				this.addVarForm.rk = row.rk;
				this.addVarForm.val = row.val;
				this.addVarsShow = true ;
			},
			addVars:function(){
				this.addVarForm.kn = "";
				this.addVarForm.rk = "";
				this.addVarForm.val = "";
				this.addVarsShow = true ;
			},
			addSaveVars:function(){
				let newadd = {
					kn:this.addVarForm.kn,
					val:this.addVarForm.val,
					rk:this.addVarForm.rk
				};
				this.removeVars(this.addVarForm.kn);
				this.loabvarstr.push(newadd);
				this.addVarsShow = false ;
			},
			clickClose:function(){},
			formatType: function (row) {
				if(row.type==1) return '系统用户:'+row.cpname;
				if(row.type==2) return '业务员:'+row.cpname;
				if(row.type==3) return '企业用户:'+row.cpname;
				return '未知';
			},
			formatValid: function (row, column) {
				return row.valid == 1 ? '有效' : row.valid == 0 ? '无效' : '未知';
			},
			formatTgs:function(row,column){
				return this.showTgs(row.provider_code);
			},
			showTgs:function(company_code){
				//console.log("查询>>>"+company_code);
				var restr = '' ;
				for(let json of this.tgs_options){
					//console.log("检测:"+json.code+"=="+company_code+"=="+company_code==json.code);
					if(company_code==json.code){
						restr = json.name;
						break ;
					}
				}
				console.log(">>>"+company_code+">>"+restr);
				return restr;
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			selectScripts(event){
				console.log(event);
			},
			selectNumbers(event){
				//选择了数据..
				console.log("获取到数据:"+this.addNumbForm.callNum);
				for(let json of this.callNumberList){
					if(this.addNumbForm.callNum==json.call_num){
						this.addNumbForm.bjqz = json.bjqz;
						break;
					}
				}
				//console.log("获取到数据:"+this.editForm);
				//this.loabvarstr = this.editForm.variables;
			},
			selectIntances(event){
				//选择了数据..
				for(let json of this.scriptDatas){
					if(this.editForm.script_id==json.script_id){
						this.editForm.instance_id = json.instance_id;
						this.editForm.provider_code = json.provider_code;
						this.editForm.name = json.name;
						this.editForm.variables = json.variables;
						break;
					}
				}
				console.log("获取到数据:"+this.editForm);
				this.loabvarstr = this.editForm.variables;
			},
			getCallNumberList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'UMPTzRDT.callnums.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.callNumberList = res.data.datas;
					}
				});
			},
			getScriptDatas(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'RkAe8K0e.callScript.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.scriptDatas = res.data.datas;
					}
				});
			},
			getTgsOptions(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'h7iJaA2.dyshop_company.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.tgs_options = res.data.datas;
					}
				});
			},
			//获取用户列表
			getLists() {
				//console.log("query");
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					provider_code: this.filters.provider_code,
					name:this.filters.name,
					actionurl:'default/getList',
					sqlid:'Uc9qKfB8.callScriptUse.query',
				};
				this.listLoading = true;
				//NProgress.start();
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
					//NProgress.done();
				});
			},
			//删除
			handleDel: function (row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { 
						id: row.id,
						actionurl:'default/del',
						sqlid:'Uc9qKfB8.callScriptUse.del'
					};
					delData(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
						this.getLists();
					});
				}).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				if(row.variables instanceof Object){
					this.loabvarstr = row.variables;
				}else{
					this.loabvarstr = [];
				}
				if(row.call_nums instanceof Object){
					this.loaNumberStr = row.call_nums;
				}else{
					this.loaNumberStr = [];
				}
				this.editForm.company_name = this.showTgs(this.editForm.company_code);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'Uc9qKfB8.callScriptUse.upt';//设置Sqlid
			},
			//显示新增界面
			handleAdd: function () {
				if(this.filters.company_code=='') {
					this.$message({message: '请选择需要话术的公司!',type: 'error'});
					return ;
				}
				this.editForm.company_code = this.filters.company_code;
				//console.log("新增");
				this.editForm.company_name = this.showTgs(this.filters.company_code);
				this.addFormVisible = true ;
				//////////
				
				//////////////////////////////////
				this.editformtitle = '新增';
				this.editForm.actionurl = "default/save";
				this.editForm.sqlid = "Uc9qKfB8.callScriptUse.add";
			},
			showScriptName:function(scriptId){
				var restr = '' ;
				this.script_opts.forEach(function(d){
					if(scriptId==d.scriptId){
						restr = d.scriptName;
						return ;
					}
				});
				return restr;
			},
			//编辑保存
			editSubmit: function () {
				//console.log('script_id>>'+this.editForm.script_id);
				this.editForm.variables = JSON.stringify(this.loabvarstr);
				let para = Object.assign({}, this.editForm);
				//util.saveFunction(this,para);
				util.saveParamFunction(this,para,'editLoading','editForm','addFormVisible');
			},
			editSaveSubmit: function () {
				//console.log('script_id>>'+this.editForm.script_id);
				this.editForm.variables = JSON.stringify(this.loabvarstr);
				this.editForm.call_nums = JSON.stringify(this.loaNumberStr);
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			tableRowClassName({row, rowIndex}) {
				if (rowIndex%2 == 0) {
					//console.log(">>>>>"+rowIndex);
					return 'warning-row';
				} else {
					return 'success-row';
				}
			}
		},
		mounted() {
			this.getCallNumberList();
			this.getScriptDatas();
			this.getTgsOptions();
			this.getLists();
		}
	}
</script>
<style>
	.text {
		font-size: 15px;
	}
	.var-text {
		font-size: 12px;
	}
	.to-right{
		position: fixed;
		right: 20px;
	}
	.item {
		margin-bottom: 5px;
		color:green;
	}
	.items {
		margin-bottom: 5px;
		color:red;
	}
	.itemmin{
		color:#858a95;
		font-size: 10px;
	}
	.div-cards {
		margin-bottom:15px;
		margin-left:25px;
		margin-right:25px;
		//width: 280px;
		height: 280px;
		padding:15px;
		border:dashed;
		border-color:#e6a23c;
		border-width:0.5px;
	}
	.div-vars{
		width: 280px;
		height: 28px;
		border:dashed;
		border-color:#e6a23c;
		border-width:0.5px;
	}
	.el-table .warning-row {
		background: oldlace;
	}
	.el-table .success-row {
		background: #f0f9eb;
	}
</style>


// WEBPACK FOOTER //
// useCallScript.vue?2bf26f1e